// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.group-profile-icon {
  background-image: url(https://assets.foursightonline.com/app/images/group-profile.png);
  width: 30px;
  background-size: cover;
  height: 23px;
}

.team-report-icon {
  background-image: url(https://assets.foursightonline.com/app/images/team-report-icon.jpg);
  width: 30px;
  background-size: cover;
  height: 23px;
  display: inline-block;
  background-repeat: no-repeat;
}

.gray-scale {
  filter: grayscale(1);
}

::ng-deep.swal2-modal {
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
}

::ng-deep .swal2-show {
  background-color: white;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  width: 478px;
  padding: 17px;
  border-radius: 5px;
  text-align: center;
  position: fixed;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  -webkit-transform: translate(0, 0) !important;
  -moz-transform: translate(0, 0) !important;
  margin-left: -256px;
  overflow: hidden;
  z-index: 99999;
  margin-top: -168px;
}
::ng-deep .swal2-show:focus {
  outline: none;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled {
  background-color: #D0D0D0 !important;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled:focus {
  outline: none;
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled {
  background-color: #AEDEF4;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled:focus {
  outline: none;
}
::ng-deep .swal2-show .swal2-icon.swal2-warning {
  width: 80px;
  height: 80px;
  border: 4px solid gray;
  border-radius: 40px;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
  border-color: #F8BB86;
  font-size: 58px;
  color: #F8BB86;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
}
::ng-deep .swal2-show .swal2-icon.swal2-warning:focus {
  outline: none;
}
::ng-deep .swal2-show h2#swal2-title {
  color: #575757;
  font-size: 30px;
  text-align: center;
  font-weight: 600;
  text-transform: none;
  position: relative;
  margin: 25px 0;
  padding: 0;
  line-height: 40px;
  display: block;
}
::ng-deep .swal2-show h2#swal2-title:focus {
  outline: none;
}
::ng-deep .swal2-show div#swal2-content {
  color: #797979;
  font-size: 16px;
  text-align: center;
  font-weight: 300;
  position: relative;
  text-align: inherit;
  float: none;
  margin: 0;
  padding: 0;
  line-height: normal;
}
::ng-deep .swal2-show div#swal2-content:focus {
  outline: none;
}

::ng-deep.swal2-modal {
  max-width: 500px !important;
  width: 100% !important;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  -webkit-transform: translate(0, 0) !important;
  -moz-transform: translate(0, 0) !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
  box-sizing: border-box !important;
  bottom: 0;
  right: 0;
  margin: auto !important;
  height: auto;
}

@media screen and (max-width: 380px) {
  ::ng-deep.swal2-modal {
    height: inherit;
  }
}
::ng-deep.swal2-icon-text {
  font-size: 1.3em;
  line-height: 1;
}

::ng-deep .swal2-shown {
  background-color: black;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999;
}

.select-color {
  color: #000;
}

.session-actions {
  width: 9%;
  padding: 5px;
  text-align: right;
}
.session-actions a {
  position: static;
  margin-bottom: 0;
}

@media screen and (max-width: 767px) {
  .teams-lists .team-actions .btn-xs {
    display: block;
  }
  .session-actions a {
    margin-bottom: 5px;
  }
  .session-actions a:last-child {
    margin-bottom: 0;
  }
}
@media screen and (max-width: 640px) {
  .page-heading .col-lg-10 {
    width: auto;
  }
  .right-side-btn {
    float: none !important;
    width: 100%;
    text-align: left;
    padding-top: 15px;
    padding-bottom: 15px;
    display: inline-block;
  }
}
@media screen and (max-width: 400px) {
  .table-striped {
    width: 400px;
  }
}
.organization-items h2 {
  font-weight: 700;
}
.organization-items--pd h2 {
  padding-top: 10px;
  margin: 0;
}
.organization-items .orgs-tabs > li > a {
  border-radius: 3px 3px 0 0;
  border-bottom: none;
  padding: 11px 20px;
}
@media only screen and (max-width: 767px) {
  .organization-items .orgs-tabs > li > a {
    padding: 7px 9px;
  }
}

.f-btn--nobdr {
  border: 0;
}

.pl {
  padding-left: 30px !important;
}

.orgs-ind-page {
  padding: 24px 24px 0;
}
@media (max-width: 991px) {
  .orgs-ind-page {
    padding: 20px 20px 0;
  }
}
@media (max-width: 640px) {
  .orgs-ind-page {
    padding: 16px 12px 0;
  }
}

.orgs-ind-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 16px;
}
@media (max-width: 640px) {
  .orgs-ind-header {
    flex-direction: column;
    align-items: flex-start;
  }
}
.orgs-ind-header__left {
  flex: 1;
}
.orgs-ind-header__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.orgs-ind-header__count {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgb(0, 173, 208), #008ba7);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.orgs-ind-header__count-label {
  font-size: 11px;
  font-weight: 500;
  opacity: 0.85;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.orgs-ind-header__title {
  font-size: 28px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.2;
}
@media (max-width: 640px) {
  .orgs-ind-header__title {
    font-size: 22px;
  }
}
.orgs-ind-header__actions {
  display: flex;
  gap: 10px;
}

.orgs-ind-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
  color: #ccc;
}
.orgs-ind-breadcrumb li {
  display: flex;
  align-items: center;
}
.orgs-ind-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
  font-size: 11px;
}
.orgs-ind-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.orgs-ind-breadcrumb li a:hover {
  color: rgb(0, 173, 208);
}
.orgs-ind-breadcrumb li.orgs-ind-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}

.orgs-ind-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-decoration: none;
}
.orgs-ind-btn--back {
  background: #fff;
  color: #676a6c;
  border-color: #e7eaec;
}
.orgs-ind-btn--back:hover {
  background: #f1f1f2;
  border-color: #ccc;
}

.orgs-ind-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 2px solid #e7eaec;
  margin-bottom: 0;
}
.orgs-ind-tabs__tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.15s ease;
  cursor: pointer;
}
.orgs-ind-tabs__tab i {
  font-size: 14px;
}
.orgs-ind-tabs__tab:hover {
  color: rgb(0, 173, 208);
  border-bottom-color: rgba(0, 173, 208, 0.3);
}
.orgs-ind-tabs__tab--active {
  color: rgb(0, 173, 208);
  border-bottom-color: rgb(0, 173, 208);
}

.orgs-ind-content {
  padding: 0 24px 48px;
}
@media (max-width: 991px) {
  .orgs-ind-content {
    padding: 0 20px 36px;
  }
}
@media (max-width: 640px) {
  .orgs-ind-content {
    padding: 0 12px 28px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/orgs-individual/orgs-individual.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA7YA;EACE,sFAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;AAgZF;;AA7YA;EACE,yFAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,4BAAA;AAgZF;;AA7YA;EACE,oBAAA;AAgZF;;AA7YA;EACE,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;AAgZF;;AA7YA;EACE,uBAAA;EACA,wEAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAgZF;AA9YE;EACE,aAAA;AAgZJ;AA7YE;EACE,oCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA+YJ;AA7YI;EACE,aAAA;AA+YN;AA3YE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA6YJ;AA3YI;EACE,aAAA;AA6YN;AAzYE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;AA2YJ;AAzYI;EACE,aAAA;AA2YN;AAvYE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AAyYJ;AAvYI;EACE,aAAA;AAyYN;AArYE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AAuYJ;AArYI;EACE,aAAA;AAuYN;;AAlYA;EACE,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACA,yBAAA;EACA,wBAAA;EACA,iCAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;AAqYF;;AAlYA;EACE;IACE,eAAA;EAqYF;AACF;AAlYA;EACE,gBAAA;EACA,cAAA;AAoYF;;AAjYA;EACE,uBAAA;EACA,iEAAA;EACA,oCAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;AAoYF;;AAjYA;EACE,WAAA;AAoYF;;AAjYA;EACE,SAAA;EACA,YAAA;EACA,iBAAA;AAoYF;AAlYE;EACE,gBAAA;EACA,gBAAA;AAoYJ;;AAhYA;EACE;IACE,cAAA;EAmYF;EAhYA;IACE,kBAAA;EAkYF;EA/XA;IACE,gBAAA;EAiYF;AACF;AA9XA;EACE;IACE,WAAA;EAgYF;EA7XA;IACE,sBAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,oBAAA;IACA,qBAAA;EA+XF;AACF;AA3XA;EACE;IACE,YAAA;EA6XF;AACF;AAzXE;EACE,gBAAA;AA2XJ;AAtXI;EACE,iBAAA;EACA,SAAA;AAwXN;AAjXM;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AAmXR;AAjXQ;EALF;IAMI,gBAAA;EAoXR;AACF;;AA7WE;EACE,SAAA;AAgXJ;;AA5WA;EACE,6BAAA;AA+WF;;AAxWA;EACE,oBAAA;AA2WF;AAzWE;EAHF;IAG8B,oBAAA;EA6W5B;AACF;AA7WE;EAJF;IAI8B,oBAAA;EAiX5B;AACF;;AA/WA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAkXF;AAhXE;EAPF;IAO8B,sBAAA;IAAwB,uBAAA;EAqXpD;AACF;AApXE;EAAU,OAAA;AAuXZ;AArXE;EAAe,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;AA2XhE;AAzXE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,8DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDvTS;ACkrBb;AAzXI;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;AA2XN;AAvXE;EACE,eAAA;EACA,gBAAA;EACA,cD7RiB;EC8RjB,SAAA;EACA,uBAAA;EACA,wEDxUS;ECyUT,gBAAA;AAyXJ;AAvXI;EATF;IAS8B,eAAA;EA2X9B;AACF;AAzXE;EAAa,aAAA;EAAe,SAAA;AA6X9B;;AA1XA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,WD9SkB;AC2qBpB;AA3XE;EACE,aAAA;EACA,mBAAA;AA6XJ;AA3XI;EAA4B,YAAA;EAAc,aAAA;EAAe,WDpTzC;ECoToE,eAAA;AAiYxF;AA/XI;EACE,cD9Te;EC+Tf,qBAAA;EACA,4BAAA;AAiYN;AAhYM;EAAU,uBD/UA;ACktBhB;AAhYI;EAAiC,cD/ThB;EC+T4C,gBAAA;AAoYjE;;AAhYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDpXW;ECqXX,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;AAmYF;AAjYE;EACE,gBAAA;EACA,cDzViB;EC0VjB,qBD5UW;AC+sBf;AAlYI;EAAU,mBDnVQ;ECmV0B,kBDpV5B;AC0tBpB;;AAjYA;EACE,aAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;AAoYF;AAlYE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDhZS;ECiZT,cD9WiB;EC+WjB,qBAAA;EACA,oCAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AAoYJ;AAlYI;EAAI,eAAA;AAqYR;AAnYI;EACE,uBDtYU;ECuYV,2CAAA;AAqYN;AAlYI;EACE,uBD3YU;EC4YV,qCD5YU;ACgxBhB;;AA/XA;EACE,oBAAA;AAkYF;AAhYE;EAHF;IAG8B,oBAAA;EAoY5B;AACF;AApYE;EAJF;IAI8B,oBAAA;EAwY5B;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../assets/styles/variables';\n\n.group-profile-icon {\n  background-image: url(https://assets.foursightonline.com/app/images/group-profile.png);\n  width: 30px;\n  background-size: cover;\n  height: 23px;\n}\n\n.team-report-icon {\n  background-image: url(https://assets.foursightonline.com/app/images/team-report-icon.jpg);\n  width: 30px;\n  background-size: cover;\n  height: 23px;\n  display: inline-block;\n  background-repeat: no-repeat;\n}\n\n.gray-scale {\n  filter: grayscale(1);\n}\n\n::ng-deep.swal2-modal {\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  -moz-flex-wrap: wrap;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -moz-justify-content: center;\n}\n\n::ng-deep .swal2-show {\n  background-color: white;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  width: 478px;\n  padding: 17px;\n  border-radius: 5px;\n  text-align: center;\n  position: fixed;\n  left: 0 !important;\n  top: 0 !important;\n  transform: translate(0, 0) !important;\n  -webkit-transform: translate(0, 0) !important;\n  -moz-transform: translate(0, 0) !important;\n  margin-left: -256px;\n  overflow: hidden;\n  z-index: 99999;\n  margin-top: -168px;\n\n  &:focus {\n    outline: none;\n  }\n\n  button.swal2-cancel.swal2-styled {\n    background-color: #D0D0D0 !important;\n    color: white;\n    border: none;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    -webkit-border-radius: 4px;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 26px 5px 0 5px;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  button.swal2-confirm.swal2-styled {\n    background-color: #AEDEF4;\n    color: white;\n    border: none;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    -webkit-border-radius: 4px;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 26px 5px 0 5px;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .swal2-icon.swal2-warning {\n    width: 80px;\n    height: 80px;\n    border: 4px solid gray;\n    -webkit-border-radius: 40px;\n    border-radius: 40px;\n    border-radius: 50%;\n    margin: 20px auto;\n    padding: 0;\n    position: relative;\n    box-sizing: content-box;\n    border-color: #F8BB86;\n    font-size: 58px;\n    color: #F8BB86;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -moz-justify-content: center;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  h2#swal2-title {\n    color: #575757;\n    font-size: 30px;\n    text-align: center;\n    font-weight: 600;\n    text-transform: none;\n    position: relative;\n    margin: 25px 0;\n    padding: 0;\n    line-height: 40px;\n    display: block;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  div#swal2-content {\n    color: #797979;\n    font-size: 16px;\n    text-align: center;\n    font-weight: 300;\n    position: relative;\n    text-align: inherit;\n    float: none;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n::ng-deep.swal2-modal {\n  max-width: 500px !important;\n  width: 100% !important;\n  left: 0 !important;\n  top: 0 !important;\n  transform: translate(0, 0) !important;\n  -webkit-transform: translate(0, 0) !important;\n  -moz-transform: translate(0, 0) !important;\n  margin-left: 0 !important;\n  margin-top: 0 !important;\n  box-sizing: border-box !important;\n  bottom: 0;\n  right: 0;\n  margin: auto !important;\n  height: auto;\n}\n\n@media screen and (max-width: 380px) {\n  ::ng-deep.swal2-modal {\n    height: inherit;\n  }\n}\n\n::ng-deep.swal2-icon-text {\n  font-size: 1.3em;\n  line-height: 1;\n}\n\n::ng-deep .swal2-shown {\n  background-color: black;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 99999;\n}\n\n.select-color {\n  color: #000;\n}\n\n.session-actions {\n  width: 9%;\n  padding: 5px;\n  text-align: right;\n\n  a {\n    position: static;\n    margin-bottom: 0;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .teams-lists .team-actions .btn-xs {\n    display: block;\n  }\n\n  .session-actions a {\n    margin-bottom: 5px;\n  }\n\n  .session-actions a:last-child {\n    margin-bottom: 0;\n  }\n}\n\n@media screen and (max-width: 640px) {\n  .page-heading .col-lg-10 {\n    width: auto;\n  }\n\n  .right-side-btn {\n    float: none !important;\n    width: 100%;\n    text-align: left;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    display: inline-block;\n  }\n\n}\n\n@media screen and (max-width: 400px) {\n  .table-striped {\n    width: 400px;\n  }\n}\n\n.organization-items {\n  h2 {\n    font-weight: 700;\n    // padding-bottom: 20px;\n  }\n\n  &--pd {\n    h2 {\n      padding-top: 10px;\n      margin:0;\n    }\n  }\n\n  .orgs-tabs {\n     & > li {\n\n      & > a {\n        border-radius: 3px 3px 0 0;\n        border-bottom: none;\n        padding: 11px 20px;\n\n        @media #{$mobile} {\n          padding: 7px 9px;\n        }\n      }\n     }\n  }\n}\n\n.f-btn {\n  &--nobdr {\n    border: 0;\n  }\n}\n\n.pl {\n  padding-left: 30px !important;\n}\n\n// ══════════════════════════════════════════════════════\n// Org Individual — /orgs design system\n// ══════════════════════════════════════════════════════\n\n.orgs-ind-page {\n  padding: 24px 24px 0;\n\n  @media (max-width: 991px) { padding: 20px 20px 0; }\n  @media (max-width: 640px) { padding: 16px 12px 0; }\n}\n\n.orgs-ind-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  gap: 16px;\n\n  @media (max-width: 640px) { flex-direction: column; align-items: flex-start; }\n\n  &__left { flex: 1; }\n\n  &__title-row { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }\n\n  &__count {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    height: 28px;\n    padding: 0 12px;\n    border-radius: 14px;\n    background: linear-gradient(135deg, $clarify-color, darken($clarify-color, 8%));\n    color: #fff;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: $font-stack;\n\n    &-label {\n      font-size: 11px;\n      font-weight: 500;\n      opacity: 0.85;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n  }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0;\n    letter-spacing: -0.02em;\n    font-family: $font-stack;\n    line-height: 1.2;\n\n    @media (max-width: 640px) { font-size: 22px; }\n  }\n\n  &__actions { display: flex; gap: 10px; }\n}\n\n.orgs-ind-breadcrumb {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: $color-neutral-mid;\n\n  li {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child)::after { content: '/'; margin: 0 8px; color: $color-neutral-mid; font-size: 11px; }\n\n    a {\n      color: $body-content-color;\n      text-decoration: none;\n      transition: color 0.15s ease;\n      &:hover { color: $clarify-color; }\n    }\n\n    &.orgs-ind-breadcrumb__current { color: $color-neutral-dark; font-weight: 600; }\n  }\n}\n\n.orgs-ind-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  text-decoration: none;\n\n  &--back {\n    background: #fff;\n    color: $body-content-color;\n    border-color: $color-grey-1;\n    &:hover { background: $color-neutral-light; border-color: $color-neutral-mid; }\n  }\n}\n\n// Tab Navigation\n.orgs-ind-tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 2px solid $color-grey-1;\n  margin-bottom: 0;\n\n  &__tab {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 10px 20px;\n    font-size: 13px;\n    font-weight: 600;\n    font-family: $font-stack;\n    color: $body-content-color;\n    text-decoration: none;\n    border-bottom: 2px solid transparent;\n    margin-bottom: -2px;\n    transition: all 0.15s ease;\n    cursor: pointer;\n\n    i { font-size: 14px; }\n\n    &:hover {\n      color: $clarify-color;\n      border-bottom-color: rgba($clarify-color, 0.3);\n    }\n\n    &--active {\n      color: $clarify-color;\n      border-bottom-color: $clarify-color;\n    }\n  }\n}\n\n.orgs-ind-content {\n  padding: 0 24px 48px;\n\n  @media (max-width: 991px) { padding: 0 20px 36px; }\n  @media (max-width: 640px) { padding: 0 12px 28px; }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
